import { createContext } from 'react';

// Provides the shared Pyodide instance to all cells in a PythonLab session.
export const PyodideContext = createContext({ pyodide: null });
